module.exports = __webpack_public_path__ + "static/img/image2_new.5183334.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image2_new.png
// module id = Ng8S
// module chunks = 0